/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersStoreUpdateOrderPIHandlerOrderPersonalInfo interface.
 */
export function instanceOfFxIdApplicationHandlersStoreUpdateOrderPIHandlerOrderPersonalInfo(value) {
    if (!('Email' in value) || value['Email'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersStoreUpdateOrderPIHandlerOrderPersonalInfoFromJSON(json) {
    return FxIdApplicationHandlersStoreUpdateOrderPIHandlerOrderPersonalInfoFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersStoreUpdateOrderPIHandlerOrderPersonalInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Email': json['Email'],
        'PhoneNumber': json['PhoneNumber'] == null ? undefined : json['PhoneNumber'],
        'IsAutoConfirm': json['IsAutoConfirm'] == null ? undefined : json['IsAutoConfirm'],
    };
}
export function FxIdApplicationHandlersStoreUpdateOrderPIHandlerOrderPersonalInfoToJSON(json) {
    return FxIdApplicationHandlersStoreUpdateOrderPIHandlerOrderPersonalInfoToJSONTyped(json, false);
}
export function FxIdApplicationHandlersStoreUpdateOrderPIHandlerOrderPersonalInfoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Email': value['Email'],
        'PhoneNumber': value['PhoneNumber'],
        'IsAutoConfirm': value['IsAutoConfirm'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersStoreUpdateOrderPIHandlerOrderPersonalInfo.js.map